import style from "./loading.module.less";

function getLoadingDiv(el) {
  return el.querySelector("div[data-role=loading]");
}
function createLoadingDiv(size = 16) {
  const div = createDiv(style["loading-mask"]);
  div.dataset.role = "loading";
  const loading = createDiv(style["loading-pacman"]);
  loading.style.setProperty("--size", size + "px");

  const loadingMan = createDiv(style["loading-man"]);
  loading.appendChild(loadingMan);
  const loadingManFill = createDiv(style["loading-man-fill"]);
  loading.appendChild(loadingManFill);
  for (let i = 0; i < 4; i++) {
    const loadingPac = createDiv(style["loading-pac"]);
    loading.appendChild(loadingPac);
  }
  div.appendChild(loading);
  return div;
}
function createDiv(className) {
  const div = document.createElement("div");
  div.className = className;
  return div;
}
export default function (el, binding) {
  const div = getLoadingDiv(el);
  if (binding.value) {
    if (!div) {
      const loading = createLoadingDiv(binding.arg);
      el.appendChild(loading);
    }
  } else {
    if (div) {
      div.remove();
    }
  }
}
